module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f99b.77c65f38.svg";